
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.221 5.625a3.654 3.654 0 00-7.304.177v3.8c0 .453.083.887.234 1.287h8.844a4 4 0 014 4v8.962a4 4 0 01-4 4H4.148a4 4 0 01-4-4V14.89a4 4 0 013.917-3.999 5.67 5.67 0 01-.148-1.289V5.802a5.654 5.654 0 0111.306-.177H13.22zm-1.765 12.567c0 .698-.379 1.306-.941 1.632v1.408a.942.942 0 11-1.885 0v-1.406a1.884 1.884 0 112.826-1.634z","fill":"#fff"}})])
          )
        }
      }
    